<template>
    <jet-form-section @submitted="updateAddressInformation">
        <template #title>
            Address Information
        </template>
        <template #description>
            Update your account's address information.
        </template>
        <template #form>
            <!-- Building/House Number -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="building" value="Building Name/House Number" />
                <jet-input id="building" type="text" class="mt-1 block w-full" v-model="form.building" style="background-color: rgb(31 41 55);"/>
                <jet-input-error :message="form.errors.building" class="mt-2" />
            </div>
            <!-- Street -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="street" value="Street" />
                <jet-input id="street" type="text" class="mt-1 block w-full" v-model="form.street" autocomplete="address-line1" style="background-color: rgb(31 41 55);"/>
                <jet-input-error :message="form.errors.street" class="mt-2" />
            </div>
            <!-- City -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="city" value="City" />
                <jet-input id="city" type="text" class="mt-1 block w-full" v-model="form.city" autocomplete="address-line2" style="background-color: rgb(31 41 55);"/>
                <jet-input-error :message="form.errors.city" class="mt-2" />
            </div>
            <!-- Postcode -->
            <div class="col-span-6 sm:col-span-4">
                <jet-label for="postcode" value="Postcode" />
                <jet-input id="postcode" type="text" class="mt-1 block w-full" autocomplete="postal-code" v-model="form.postcode" style="background-color: rgb(31 41 55);"/>
                <jet-input-error :message="form.errors.postcode" class="mt-2" />
            </div>
        </template>
        <template #actions>
            <jet-action-message :on="form.recentlySuccessful" class="mr-3">
                Saved.
            </jet-action-message>
            <jet-button :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Save
            </jet-button>
        </template>
    </jet-form-section>
</template>
<script>
import JetButton from '@/Jetstream/Button.vue'
import JetFormSection from '@/Jetstream/FormSection.vue'
import JetInput from '@/Jetstream/Input.vue'
import JetInputError from '@/Jetstream/InputError.vue'
import JetLabel from '@/Jetstream/Label.vue'
import JetActionMessage from '@/Jetstream/ActionMessage.vue'
import JetSecondaryButton from '@/Jetstream/SecondaryButton.vue'

export default {
    components: {
        JetActionMessage,
        JetButton,
        JetFormSection,
        JetInput,
        JetInputError,
        JetLabel,
        JetSecondaryButton,
    },

    props: ['user'],

    data() {
        return {
            form: this.$inertia.form({
                _method: 'PUT',
                building: this.user.building,
                street: this.user.street,
                city: this.user.city,
                postcode: this.user.postcode,
                country_id: this.user.country_id ? this.user.country_id : 169,
            })
        }
    },

    methods: {
        updateAddressInformation() {
            this.form.post(route('user-address-information.update'), {
                errorBag: 'updateAddressInformation',
                preserveScroll: true,
            });
        }
    }
}

</script>
